// extracted by mini-css-extract-plugin
export default {"toggleEntry":"s2s3Vdnbg0rrqYE79RSY"};